import { UserConfig } from '../types/user';


export const isFokusEmail = (email: string) => {
  return email.split('@')[0] === 'fokus';
};


export const isFokusUser = (userConfig: UserConfig | null) => {
  return userConfig !== null && isFokusEmail(userConfig.email);
};
